// extracted by mini-css-extract-plugin
export default {"subTitle":"Logout_subTitle__cUSQn","logoutTitle":"Logout_logoutTitle__ed3Fq","confirmation":"Logout_confirmation__SITmD"};